export default __webpack_public_path__ + "3d8bb7b8bdbd68e52fb744e5b92b903b.svg";